module.exports = __webpack_public_path__ + "img/user.ae92b0a7.svg";